import React from 'react';
import forecastHeroArt from '../../../assets/forecast-header-misty-mountains.png';
import forecastHeroArtWide from '../../../assets/forecast-header-misty-mountains-wide.jpg';
import { ArrowIcon, CalendarIcon } from './icons';
import { formatTodayChip, getTimeOfDayGreeting } from './helpers';
import styles from './ForecastPage.module.css';

export default function ForecastHero({ firstName, subtitle, onContinuePlan }) {
  return (
    <div className={styles.forecastIntro}>
      <div className={styles.pageHeading}>
        <div className={styles.pageHeadingCopy}>
          <h1 className={styles.pageTitle}>Forecast</h1>
          <p className={styles.pageSubtitle}>Your financial outlook, insights and next steps.</p>
        </div>
        <p className={styles.dateChip}>
          <CalendarIcon />
          <span>{formatTodayChip()}</span>
        </p>
      </div>
      <header className={styles.heroBanner}>
        <div className={styles.heroCopy}>
          <p className={styles.heroGreeting}>
            {getTimeOfDayGreeting()}, {firstName}
            {' '}
            <span className={styles.heroWave} aria-hidden="true">👋</span>
          </p>
          <h2 className={styles.heroTitle}>
            {firstName}, step into a new chapter of
            <span className={styles.heroTitleBreak} />
            {' '}
            financial calm and control.
          </h2>
          <p className={styles.heroSubtitle}>{subtitle}</p>
          <button type="button" className={styles.heroCta} onClick={onContinuePlan}>
            Your Next Best Money Move
            <ArrowIcon className={styles.heroCtaArrow} />
          </button>
        </div>
        <p className={styles.heroQuote}>
          Your Next
          <br />
          Chapter Starts
          <br />
          Now.
        </p>
        <picture>
          <source media="(min-width: 769px)" srcSet={forecastHeroArtWide} />
          <img
            src={forecastHeroArt}
            alt=""
            className={styles.heroArt}
            decoding="async"
          />
        </picture>
      </header>
    </div>
  );
}
